<template>
  <Panel
    class="template-documentos-editor-panel"
    lineColor="var(--secondary-color)"
  >
    <p class="template-documentos-editor-titulo">
      <v-icon size="14" color="primario">fas fa-code</v-icon>
      HTML do template
    </p>
    <FormText
      ref="formText"
      :value="value"
      :rows="rows"
      :disabled="disabled"
      @input="$emit('input', $event)"
      class="mb-n5"
    />
  </Panel>
</template>

<script>
import Panel from "@/components/Panel";
import FormText from "@/components/form/FormText";
import {
  formatVariavelToken,
  insertTokenAtCursor
} from "../template-documentos.constants";

export default {
  name: "TemplateDocumentosEditor",
  components: { Panel, FormText },
  props: {
    value: { type: String, default: "" },
    rows: { type: Number, default: 22 },
    disabled: { type: Boolean, default: false }
  },
  methods: {
    inserirVariavel(chave) {
      const textarea = this.$refs.formText.$el.querySelector("textarea");
      const token = formatVariavelToken(chave);
      const result = insertTokenAtCursor(textarea, token);
      if (!result) {
        this.$emit("input", (this.value || "") + token);
        return;
      }
      this.$emit("input", result.value);
      this.$nextTick(() => {
        textarea.focus();
        textarea.setSelectionRange(result.selectionStart, result.selectionEnd);
      });
    }
  }
};
</script>

<style scoped>
.template-documentos-editor-panel {
  height: 100%;
}

.template-documentos-editor-titulo {
  display: flex;
  align-items: center;
  gap: 8px;
  font-weight: 700;
  margin-bottom: 16px;
}
</style>
